<div class="build-upload-block">
    <div class="flex-start">
        <div (dragover)="onDragOver($event)" (drop)="onDropSuccess($event)">
            <input id="importFileUpload" type="file" (change)="addFile($event)" [multiple]="false" accept=".xlsx" />
        </div>
        <div class="btnList">
            <button class="button-red importbtn" (click)="validateData()">Upload</button>
            <button class="button-teritory importbtn" (click)="cancelUpload()">
                Cancel
            </button>
        </div>
    </div>
</div>